$(document).ready(function() {
    // Initialize the main product image slider
    $('.js-slider-primary').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      speed: 150, // Faster transition for more immediate feedback
      asNavFor: '.pdp-slider-thumb',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            asNavFor: null,
            dots: true,
          }
        },
      ]
    });

    // Initialize the thumbnail slider
    $('.pdp-slider-thumb').slick({
      slidesToShow: 7,
      infinite: false,
      slidesToScroll: 1,
      gutter: 10,
      vertical: true,
      prevArrow: "<a href='#' class='previous-arrow' aria-label='Previous Slide'><svg xmlns='http://www.w3.org/2000/svg' height='16' width='10' viewBox='0 0 320 512'><path d='M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z'/></svg></a>",
      nextArrow: "<a href='#' class='next-arrow' aria-label='Next Slide'><svg xmlns='http://www.w3.org/2000/svg' height='16' width='10' viewBox='0 0 320 512'><path d='M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z'/></svg></a>",
      asNavFor: '.js-slider-primary',
      focusOnSelect: true,
    });

    // Debounce para hover y guardias de inicialización
    var hoverTimer = null;
    // Fallback por inactividad: resetea a top tras 400ms fuera del área
    var resetTimer = null;
    const thumbItems = document.querySelectorAll('.pdp-single-thumb');
    const mainSlider = $('.js-slider-primary').slick('getSlick');
    
    // Function to update active state on thumbnails
    function updateActiveThumb(index) {
      thumbItems.forEach(item => item.classList.remove('active'));
      if (thumbItems[index]) {
        thumbItems[index].classList.add('active');
      }
    }

    // Al salir del área de thumbnails o del bloque de fotos, volver a la parte superior (index 0) tras 400ms
    $('.pdp-product-thumbs, .pdp-slider-thumb, .product-photos')
      .on('mouseenter', function () {
        // si vuelve a entrar, cancelar el reset pendiente
        clearTimeout(resetTimer);
      })
      .on('mouseleave', function () {
        // Evita intervenir en mobile donde los thumbs no actúan como nav
        if (window.matchMedia('(max-width: 991px)').matches) return;
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          var $thumbs = $('.pdp-slider-thumb');
          if ($thumbs.hasClass('slick-initialized')) {
            var currentThumb = $thumbs.slick('slickCurrentSlide');
            if (currentThumb !== 0) {
              $thumbs.slick('slickGoTo', 0, true);
              // Fuerza re-cálculo de posiciones
              requestAnimationFrame(function(){
                $thumbs.slick('setPosition');
                // Segundo reflow por seguridad
                requestAnimationFrame(function(){
                  $thumbs.slick('setPosition');
                });
              });
            }
          }
        }, 400);
      });

    // Handle hover events on thumbnails
    thumbItems.forEach((item, index) => {
      // On mouse enter (hover)
      item.addEventListener('mouseenter', function() {
        // Immediately go to this slide without animation
        $('.js-slider-primary').slick('slickGoTo', index, true);
        updateActiveThumb(index);
      });
    });

    // Handle click events for mobile/touch devices
    thumbItems.forEach((item, index) => {
      item.addEventListener('click', function(e) {
        // Prevent default click behavior to avoid conflicts
        e.preventDefault();
        // Go to this slide
        $('.js-slider-primary').slick('slickGoTo', index);
        updateActiveThumb(index);
      });
    });

    // Update active state when main slider changes (e.g., by arrow navigation)
    $('.js-slider-primary').on('afterChange', function(event, slick, currentSlide) {
      updateActiveThumb(currentSlide);
    });

    // Set initial active state
    updateActiveThumb(0);
});